import React from 'react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { Swiper } from 'swiper/react'
import { Navigation, Mousewheel, Keyboard } from 'swiper'
import { CarouselStyle } from '../style'
import { CarouselWrapper } from '../swiperNav/style'
import './navStyle.css'

export interface SwiperWrapperProps {
  breakpoints: any
  arrowColor?: string
  sections?: React.ReactNode
  swiperId?: string
}

export interface ICarouselNavItems {
  name: string
  itemHash: string
}

export const SwiperNav = ({
  breakpoints,
  arrowColor = 'var(--primary)',
  sections,
  swiperId = 'nav-default'
}: SwiperWrapperProps): JSX.Element => {
  const prevButtonId = `nav-prev-${swiperId}`
  const nextButtonId = `nav-next-${swiperId}`

  return (
    <CarouselWrapper>
      <CarouselStyle arrowColor={arrowColor} isMenu={true}>
        <Swiper
          keyboard={{
            enabled: true
          }}
          breakpoints={breakpoints}
          modules={[Mousewheel, Navigation, Keyboard]}
          navigation={{
            nextEl: `#${nextButtonId}`,
            prevEl: `#${prevButtonId}`
          }}
          allowSlideNext={true}
          mousewheel={true}
          grabCursor={true}
        >
          {sections}
        </Swiper>
        <div id={prevButtonId} className={'swiper-button-prev'}/>
        <div id={nextButtonId} className={'swiper-button-next'}/>
      </CarouselStyle>
    </CarouselWrapper >
  )
}
